module.exports = __webpack_public_path__ + "img/fy9.3136bf0d.jpg";